/**
 * ESOS API Documentation
 * ESOS API Documentation
 *
 * The version of the OpenAPI document: uk-esos-app-api 0.81.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpClient, HttpEvent, HttpHeaders, HttpParameterCodec, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';

import { Configuration } from '../configuration';
import { CustomHttpParameterCodec } from '../encoder';
import { CustomMiReportParams } from '../model/customMiReportParams';
import { EmptyMiReportParams } from '../model/emptyMiReportParams';
import { ExecutedRequestActionsMiReportParams } from '../model/executedRequestActionsMiReportParams';
import { MiReportResult } from '../model/miReportResult';
import { MiReportSearchResult } from '../model/miReportSearchResult';
import { OutstandingRegulatorRequestTasksMiReportParams } from '../model/outstandingRegulatorRequestTasksMiReportParams';
import { BASE_PATH } from '../variables';

@Injectable({
  providedIn: 'root',
})
export class MiReportsService {
  protected basePath = 'http://localhost:8080/api';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)),
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Generates custom report
   * @param accountType The account type
   * @param customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public generateCustomReport(
    accountType: 'ORGANISATION',
    customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams:
      | CustomMiReportParams
      | EmptyMiReportParams
      | ExecutedRequestActionsMiReportParams
      | OutstandingRegulatorRequestTasksMiReportParams,
  ): Observable<MiReportResult>;
  public generateCustomReport(
    accountType: 'ORGANISATION',
    customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams:
      | CustomMiReportParams
      | EmptyMiReportParams
      | ExecutedRequestActionsMiReportParams
      | OutstandingRegulatorRequestTasksMiReportParams,
    observe: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpResponse<MiReportResult>>;
  public generateCustomReport(
    accountType: 'ORGANISATION',
    customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams:
      | CustomMiReportParams
      | EmptyMiReportParams
      | ExecutedRequestActionsMiReportParams
      | OutstandingRegulatorRequestTasksMiReportParams,
    observe: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpEvent<MiReportResult>>;
  public generateCustomReport(
    accountType: 'ORGANISATION',
    customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams:
      | CustomMiReportParams
      | EmptyMiReportParams
      | ExecutedRequestActionsMiReportParams
      | OutstandingRegulatorRequestTasksMiReportParams,
    observe: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<MiReportResult>;
  public generateCustomReport(
    accountType: 'ORGANISATION',
    customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams:
      | CustomMiReportParams
      | EmptyMiReportParams
      | ExecutedRequestActionsMiReportParams
      | OutstandingRegulatorRequestTasksMiReportParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<any> {
    if (accountType === null || accountType === undefined) {
      throw new Error('Required parameter accountType was null or undefined when calling generateCustomReport.');
    }
    if (
      customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams ===
        null ||
      customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams ===
        undefined
    ) {
      throw new Error(
        'Required parameter customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams was null or undefined when calling generateCustomReport.',
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    const credential = this.configuration.lookupCredential('bearerAuth');
    if (credential) {
      headers = headers.set('Authorization', 'Bearer ' + credential);
    }

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType_ = 'text';
    }

    return this.httpClient.post<MiReportResult>(
      `${this.configuration.basePath}/v1.0/${encodeURIComponent(String(accountType))}/mireports/custom`,
      customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams,
      {
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Generates the report identified by the provided report type
   * @param accountType The account type
   * @param customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public generateReport(
    accountType: 'ORGANISATION',
    customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams:
      | CustomMiReportParams
      | EmptyMiReportParams
      | ExecutedRequestActionsMiReportParams
      | OutstandingRegulatorRequestTasksMiReportParams,
  ): Observable<MiReportResult>;
  public generateReport(
    accountType: 'ORGANISATION',
    customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams:
      | CustomMiReportParams
      | EmptyMiReportParams
      | ExecutedRequestActionsMiReportParams
      | OutstandingRegulatorRequestTasksMiReportParams,
    observe: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpResponse<MiReportResult>>;
  public generateReport(
    accountType: 'ORGANISATION',
    customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams:
      | CustomMiReportParams
      | EmptyMiReportParams
      | ExecutedRequestActionsMiReportParams
      | OutstandingRegulatorRequestTasksMiReportParams,
    observe: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpEvent<MiReportResult>>;
  public generateReport(
    accountType: 'ORGANISATION',
    customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams:
      | CustomMiReportParams
      | EmptyMiReportParams
      | ExecutedRequestActionsMiReportParams
      | OutstandingRegulatorRequestTasksMiReportParams,
    observe: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<MiReportResult>;
  public generateReport(
    accountType: 'ORGANISATION',
    customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams:
      | CustomMiReportParams
      | EmptyMiReportParams
      | ExecutedRequestActionsMiReportParams
      | OutstandingRegulatorRequestTasksMiReportParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<any> {
    if (accountType === null || accountType === undefined) {
      throw new Error('Required parameter accountType was null or undefined when calling generateReport.');
    }
    if (
      customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams ===
        null ||
      customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams ===
        undefined
    ) {
      throw new Error(
        'Required parameter customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams was null or undefined when calling generateReport.',
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    const credential = this.configuration.lookupCredential('bearerAuth');
    if (credential) {
      headers = headers.set('Authorization', 'Bearer ' + credential);
    }

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType_ = 'text';
    }

    return this.httpClient.post<MiReportResult>(
      `${this.configuration.basePath}/v1.0/${encodeURIComponent(String(accountType))}/mireports`,
      customMiReportParamsEmptyMiReportParamsExecutedRequestActionsMiReportParamsOutstandingRegulatorRequestTasksMiReportParams,
      {
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Retrieves the mi report types for current user
   * @param accountType The account type
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCurrentUserMiReports(accountType: 'ORGANISATION'): Observable<Array<MiReportSearchResult>>;
  public getCurrentUserMiReports(
    accountType: 'ORGANISATION',
    observe: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpResponse<Array<MiReportSearchResult>>>;
  public getCurrentUserMiReports(
    accountType: 'ORGANISATION',
    observe: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpEvent<Array<MiReportSearchResult>>>;
  public getCurrentUserMiReports(
    accountType: 'ORGANISATION',
    observe: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<Array<MiReportSearchResult>>;
  public getCurrentUserMiReports(
    accountType: 'ORGANISATION',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<any> {
    if (accountType === null || accountType === undefined) {
      throw new Error('Required parameter accountType was null or undefined when calling getCurrentUserMiReports.');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    const credential = this.configuration.lookupCredential('bearerAuth');
    if (credential) {
      headers = headers.set('Authorization', 'Bearer ' + credential);
    }

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    let responseType_: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType_ = 'text';
    }

    return this.httpClient.get<Array<MiReportSearchResult>>(
      `${this.configuration.basePath}/v1.0/${encodeURIComponent(String(accountType))}/mireports/types`,
      {
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get regulator related request task types
   * @param accountType The account type
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRegulatorRequestTaskTypes(accountType: 'ORGANISATION'): Observable<Array<string>>;
  public getRegulatorRequestTaskTypes(
    accountType: 'ORGANISATION',
    observe: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpResponse<Array<string>>>;
  public getRegulatorRequestTaskTypes(
    accountType: 'ORGANISATION',
    observe: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpEvent<Array<string>>>;
  public getRegulatorRequestTaskTypes(
    accountType: 'ORGANISATION',
    observe: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<Array<string>>;
  public getRegulatorRequestTaskTypes(
    accountType: 'ORGANISATION',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<any> {
    if (accountType === null || accountType === undefined) {
      throw new Error(
        'Required parameter accountType was null or undefined when calling getRegulatorRequestTaskTypes.',
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    const credential = this.configuration.lookupCredential('bearerAuth');
    if (credential) {
      headers = headers.set('Authorization', 'Bearer ' + credential);
    }

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    let responseType_: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType_ = 'text';
    }

    return this.httpClient.get<Array<string>>(
      `${this.configuration.basePath}/v1.0/${encodeURIComponent(String(accountType))}/mireports/request-task-types`,
      {
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }
}
